var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sb-panel',{attrs:{"variation":_vm.variation}},[_vm._t("header"),_vm._v(" "),_c('expand-transition',{attrs:{"overflow":"visible","overflow-el":_vm.$el},on:{"leavecomplete":_vm.handleCollapseFinished}},[(!_vm.collapse)?_vm._t("default"):_vm._e()],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }